// Directory Header - logo, title, and partner count chip

import React from 'react'
import { Box, Typography, Stack, Chip, IconButton, Tooltip } from '@mui/material'
import GetAppIcon from '@mui/icons-material/GetApp'

import poolwerxLogo from '../../../assets/poolwerx-logo.png'
import { poolwerxColors } from '../../../theme/colors'

interface DirectoryHeaderProps {
  partnerCount: number
  isMobile: boolean
  isInstallable?: boolean
  onInstall?: () => void
}

const DirectoryHeader: React.FC<DirectoryHeaderProps> = ({
  partnerCount,
  isMobile,
  isInstallable,
  onInstall
}) => (
  <Box sx={{
    backgroundColor: poolwerxColors.teal,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    borderBottom: '1px solid #e0e0e0',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    px: { xs: 2, sm: 3 }
  }}>
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="space-between"
      sx={{ width: '100%' }}
    >
      {/* Left: Logo */}
      <Box sx={{ flexShrink: 0 }}>
        <img
          src={poolwerxLogo}
          alt="Poolwerx"
          style={{ height: 40 }}
        />
      </Box>

      {/* Center: Title */}
      <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
        {!isMobile && (
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: 'white',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              fontSize: '1.1rem'
            }}
          >
            Franchise Partner Directory
          </Typography>
        )}
      </Box>

      {/* Right: Install button + Partner count chip */}
      <Stack direction="row" spacing={1} alignItems="center" sx={{ flexShrink: 0 }}>
        {isInstallable && onInstall && (
          <Tooltip title="Install as App">
            <IconButton
              onClick={onInstall}
              size="small"
              sx={{
                color: 'white',
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.25)'
                }
              }}
            >
              <GetAppIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        <Chip
          label={`${partnerCount} partners`}
          size="small"
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            color: 'white',
            fontWeight: 500
          }}
        />
      </Stack>
    </Stack>
  </Box>
)

export default DirectoryHeader
